import { c as _c } from "react/compiler-runtime";
import { Link, type LinkProps } from '@/components/links';
import { Text } from '@/components/typography';
import { type ReactNode } from 'react';
import Image from 'next/image';
export interface RewardBoxProps {
  image: string;
  title: string;
  link: LinkProps;
}
export function RewardBox(props) {
  const $ = _c(10);
  const {
    image,
    link,
    title
  } = props;
  let t0;
  if ($[0] !== image || $[1] !== title) {
    t0 = <span className="relative block aspect-[3/2]"><Image src={image} alt={title} className="h-full w-full rounded-lg object-cover" width={236} height={155} /></span>;
    $[0] = image;
    $[1] = title;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== title) {
    t1 = <span className="mt-2 block md:mt-4"><Text as="span" variant="p3" weight="semibold" className="line-clamp-2 px-1 text-gray-900 lg:px-2">{title}</Text></span>;
    $[3] = title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== link || $[6] !== t0 || $[7] !== t1 || $[8] !== title) {
    t2 = <Link {...link} className="shadow-card mx-auto block max-w-[268px] rounded-2xl bg-white p-2 no-underline transition transition-shadow duration-100 ease-in hover:shadow-lg md:p-4" title={title}>{t0}{t1}</Link>;
    $[5] = link;
    $[6] = t0;
    $[7] = t1;
    $[8] = title;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}